/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartResetPasswordResponse
 */
export interface StartResetPasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof StartResetPasswordResponse
     */
    resetFlow: StartResetPasswordResponseResetFlowEnum;
}


/**
 * @export
 */
export const StartResetPasswordResponseResetFlowEnum = {
    StartResetPassword: 'START_RESET_PASSWORD',
    RegenerateTemporaryPassword: 'REGENERATE_TEMPORARY_PASSWORD'
} as const;
export type StartResetPasswordResponseResetFlowEnum = typeof StartResetPasswordResponseResetFlowEnum[keyof typeof StartResetPasswordResponseResetFlowEnum];


/**
 * Check if a given object implements the StartResetPasswordResponse interface.
 */
export function instanceOfStartResetPasswordResponse(value: object): value is StartResetPasswordResponse {
    if (!('resetFlow' in value) || value['resetFlow'] === undefined) return false;
    return true;
}

export function StartResetPasswordResponseFromJSON(json: any): StartResetPasswordResponse {
    return StartResetPasswordResponseFromJSONTyped(json, false);
}

export function StartResetPasswordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartResetPasswordResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'resetFlow': json['resetFlow'],
    };
}

export function StartResetPasswordResponseToJSON(json: any): StartResetPasswordResponse {
    return StartResetPasswordResponseToJSONTyped(json, false);
}

export function StartResetPasswordResponseToJSONTyped(value?: StartResetPasswordResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resetFlow': value['resetFlow'],
    };
}

